module.exports = __webpack_public_path__ + "static/media/CompanyImage2.5385a5dd.jpg";